import React, { FC } from 'react';
import { RodRequest } from '@bechtel/types';
import { RodRequestDetails } from '~/components/organisms/rod-request-details';
import { RodRequestDetailContainerStyled } from './styled';
import { RodRequestDetailsHeader } from './header/internals';

interface RodRequestItemDetailProps {
  rodRequestDetail: RodRequest;
}

export const RodRequestItemDetail: FC<RodRequestItemDetailProps> = ({ rodRequestDetail }) => {
  return (
    <RodRequestDetailContainerStyled>
      <RodRequestDetailsHeader rodRequestItem={rodRequestDetail} />
      <RodRequestDetails rodRequest={rodRequestDetail} />
    </RodRequestDetailContainerStyled>
  );
};
